export async function addScribbleScore({
  token,
  userId,
  lobby_name,
  points,
  time_sec,
  themeName,
  stageId,
  turnIndex,
  guessText,
  isGameComplete,
  role,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/addScribbleScore`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      lobby_name,
      points,
      time_sec,
      ...(themeName ? { themeName } : {}),
      ...(stageId != null && String(stageId).trim() !== "" ? { stageId } : {}),
      ...(turnIndex != null ? { turnIndex } : {}),
      ...(guessText != null ? { guessText } : {}),
      ...(isGameComplete != null ? { isGameComplete } : {}),
      ...(role != null && String(role).trim() !== "" ? { role: String(role).trim() } : {}),
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || "Failed to save score");
  if (data && data.success === false) throw new Error(data.message || "Failed to save score");
  return data;
}
